
import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import { Bar, Line, mixins } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

@Component({})
export default class BarAndLineChart extends Mixins(
  Bar,
  Line,
  Vue,
  mixins.reactiveProp,
) {
  @Prop({
    type: Object,
    default: null,
  })
  options!: Chart.ChartOptions | null;

  mounted() {
    this.addPlugin(ChartDataLabels);
    if (this.chartData && this.options) {
      this.renderChart(this.chartData, this.options);
    }
  }
}
